import React from 'react';
import { Modal, Row } from 'react-bootstrap';
import {
  hideCloneOutletProgress,
  submitCloneOutlet,
  isCloning,
  resetCloneResult,
  resetCloningProgress,
  showCloneOutletOption,
  cloneSuccessAndConfirmed,
  removeCloneOutletId,
  deleteCloneCacheOnSuccess,
} from 'actions/outletPages/list';
import * as actNotif from 'actions/notifications';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import * as clevertapOutletsList from 'clevertap/outlets/list';
import styles from './CloneOutletModal.css';
import LoadingItem from './LoadingItem/LoadingItem';

const REFRESH_INTERVAL = 5000;
const LIBRARY_PATH = '/library/list';

export class CloneOutletModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      components: [
        { key: 1, name: 'Item Library', loading: false, done: false },
        { key: 2, name: 'Gratuity', loading: false, done: false },
        { key: 3, name: 'Modifiers', loading: false, done: false },
        { key: 4, name: 'Sales Type', loading: false, done: false },
        { key: 5, name: 'Categories', loading: false, done: false },
        { key: 6, name: 'Ingredients', loading: false, done: false },
        { key: 7, name: 'Discounts', loading: false, done: false },
        { key: 8, name: 'Ingredient Categories', loading: false, done: false },
        { key: 9, name: 'Taxes', loading: false, done: false },
        { key: 10, name: 'Recipes', loading: false, done: false },
      ],
      loadingIdx: 0,
      loading: true,
      itemName: '',
      hideModalOnMobile: false,
    };
    this.startLoading = this.startLoading.bind(this);
  }

  componentDidMount() {
    this.setState({
      hideModalOnMobile: window.innerWidth <= 992,
    });
    this.startLoading();
    this.interval = setInterval(() => this.startLoading(), REFRESH_INTERVAL);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { showModal, outlet } = this.props;
    return (
      <Modal
        show={showModal && !this.state.hideModalOnMobile}
        dialogClassName={`${styles.dialog} 
          ${
            this.state.loading
              ? ''
              : this.props.cloneResult &&
                this.props.cloneResult.success === false
              ? styles['modal-failed']
              : styles['modal-success']
          }`}
      >
        <Modal.Body>
          {this.state.loading ? (
            <div>
              <div className={styles['text-center']}>
                {this.state.itemName ? (
                  <h4 className={styles.title}>
                    {this.state.itemName} is being duplicated from{' '}
                    {outlet.source_clone_name} to{' '}
                    {outlet.destination_outlet_name}
                  </h4>
                ) : (
                  <h4 className={styles.title}>Please wait a moment.</h4>
                )}
              </div>
              <div className={styles['text-center']}>
                <p className={styles['sub-title']}>
                  You can't make changes for now in this page. Please wait for a
                  moment. <br />
                  You can go to other pages in backoffice while waiting.
                </p>
              </div>
              <div>
                <Row className={styles['row-center']}>
                  {this.state.components.map(element => (
                    <LoadingItem key={element.key} element={element} />
                  ))}
                </Row>
              </div>
            </div>
          ) : (
            <div>
              {this.state.cloneSuccess ||
              (this.props.cloneResult && this.props.cloneResult.success) ? (
                <div className={styles['text-center']}>
                  <span className={`fa fa-check-circle fa-5x ${styles.done}`} />
                  <div>
                    <h4 className={styles.title}>
                      Congratulation! <br /> Cloning from{' '}
                      {outlet.source_clone_name} to{' '}
                      {outlet.destination_outlet_name} is complete.
                    </h4>
                  </div>
                  <div>
                    <p className={styles['sub-title']}>
                      You can now make changes to your new outlet's item library
                      that <br /> have been cloned from existing outlet.
                    </p>
                  </div>
                </div>
              ) : (
                <div className={styles['text-center']}>
                  <span className={`fa fa-times-circle fa-5x ${styles.fail}`} />
                  <div>
                    <h4 className={styles.title}>
                      {outlet.source_clone_name &&
                      outlet.destination_outlet_name ? (
                        <div>
                          Cloning from {outlet.source_clone_name} to{' '}
                          {outlet.destination_outlet_name} failed.
                        </div>
                      ) : (
                        <div>Cloning Failed</div>
                      )}
                    </h4>
                  </div>
                  <div>
                    <p className={styles['sub-title']}>
                      We apologized for any inconvenience, but an unexpected
                      error <br /> occured while we were cloning your outlet.
                      Please try again to clone <br /> your outlet.
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        {!this.state.loading ? (
          <Modal.Footer className={`${styles['modal-footer']}`}>
            {this.state.cloneSuccess ||
            (this.props.cloneResult && this.props.cloneResult.success) ? (
              <div className="">
                <button
                  type="button"
                  className="btn btn-primary center-block"
                  onClick={this._onSuccess}
                >
                  Go to new outlet
                </button>
              </div>
            ) : (
              <div className="form-group row">
                <div className={`col-md-6 ${styles['text-center']}`}>
                  <button
                    type="button"
                    className={`btn btn-default ${styles['custom-button']}`}
                    onClick={this._onCancelFail}
                  >
                    Cancel
                  </button>
                </div>
                <div className={`col-md-6 ${styles['text-center']}`}>
                  <button
                    type="button"
                    className={`btn btn-primary ${styles['custom-button']}`}
                    onClick={this._onRetry}
                  >
                    Retry
                  </button>
                </div>
              </div>
            )}
          </Modal.Footer>
        ) : null}
      </Modal>
    );
  }

  _onCancelFail = () => {
    this.props.dispatch(hideCloneOutletProgress());
    this.props.dispatch(showCloneOutletOption(false));
    this.props.dispatch(deleteCloneCacheOnSuccess());
    this.props.dispatch(resetCloneResult());
    this.props.dispatch(resetCloningProgress());
    this.props.dispatch(actNotif.success('Outlet successfully created.'));
  };

  _onSuccess = () => {
    this.props.dispatch(cloneSuccessAndConfirmed(this.props.outlet));
    const location = {
      pathname: LIBRARY_PATH,
    };
    this.props.dispatch(push(location));
    this.props.dispatch(removeCloneOutletId());
  };

  _onRetry = () => {
    const outletParam = {};
    outletParam.destination_outlet_id = this.props.outlet.destination_outlet_id;
    outletParam.source_outlet_id = this.props.outlet.source_clone_id;
    outletParam.source_outlet_name = this.props.outlet.source_clone_name;
    outletParam.destination_outlet_name = this.props.outlet.destination_outlet_name;

    this.props.dispatch(resetCloneResult());
    this.props.dispatch(resetCloningProgress());
    this.props.dispatch(submitCloneOutlet(outletParam));

    this.setState({
      loading: true,
    });
    this.interval = setInterval(() => this.startLoading(), REFRESH_INTERVAL);
  };

  startLoading() {
    if (this.props.updateCloningProgress) {
      const data = this.props.updateCloningProgress.single_sub_jobs;
      const isSuccess = this.props.updateCloningProgress.success;
      let count = 0;
      data.forEach(element => {
        if (element.success) {
          count++;
        }
      });
      if (count <= this.state.components.length && isSuccess === null) {
        this.checkFinishedTask(count);
      } else {
        if (isSuccess === true) {
          clevertapOutletsList.cloneOutletSuccess();
        } else {
          clevertapOutletsList.cloneOutletFailed();
        }
        clearInterval(this.interval);
        this.setState({
          loading: false,
        });
        return;
      }
    }

    if (
      this.props.cloneResult &&
      this.props.cloneResult.outlet &&
      !this.props.cloneResult.success
    ) {
      clevertapOutletsList.cloneOutletFailed();
      clearInterval(this.interval);
      this.setState({
        loading: false,
      });
      return;
    }
    this.props.dispatch(isCloning());
  }

  checkFinishedTask(count) {
    const components = [...this.state.components];
    let element = {};
    let latestIdx = 0;

    let idx = 0;
    for (let i = 0; i < count; i++) {
      element = components[idx];
      if (!element.loading) {
        element.loading = true;
      }
      if (!element.done) {
        element.done = true;
      }
      components[idx] = element;

      idx += 2;
      if (idx === this.state.components.length) {
        idx = 1;
      }
      latestIdx = idx;
    }

    if (latestIdx < this.state.components.length) {
      const nextElement = components[latestIdx];
      nextElement.loading = true;
      components[latestIdx] = nextElement;
      this.setState({
        itemName: nextElement.name,
      });
    }

    this.setState({
      components,
    });
  }
}

function mapStateToProps(state) {
  const {
    updateCloningProgress,
    cloneResult,
    outlets,
  } = state.outletPages.list;
  return {
    updateCloningProgress,
    cloneResult,
    outlets,
  };
}

export default connect(mapStateToProps)(CloneOutletModal);
